import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-lg w-full mx-auto px-4" }
const _hoisted_2 = { class: "space-y-2" }
const _hoisted_3 = { class: "text-gray-800 font-semibold text-3xl" }
const _hoisted_4 = { class: "text-gray-800 font-medium" }
const _hoisted_5 = { class: "text-gray-600 text-sm" }
const _hoisted_6 = { class: "text-gray-600 text-sm mt-4" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "text-gray-600 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('success_payment.title')), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('success_payment.subtitle')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('success_payment.text_1')), 1),
      _createElementVNode("p", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.$t('success_payment.text_2')) + " ", 1),
        _createElementVNode("a", {
          href: _ctx.publicUrl('contacts'),
          target: "_blank",
          class: "text-blue-500 hover:underline"
        }, _toDisplayString(_ctx.$t('success_payment.text_3')), 9, _hoisted_7),
        _cache[0] || (_cache[0] = _createTextVNode("."))
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.$t('success_payment.text_4')) + " ", 1),
        _createVNode(_component_router_link, {
          to: "/subscription",
          class: "text-blue-500 hover:underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('success_payment.text_5')), 1)
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createTextVNode("."))
      ]),
      _createVNode(_component_router_link, {
        to: "/",
        class: "mt-3 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('success_payment.to_galleries')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}